<template>
  <div class="Fiche__image">
    <api-picture
      v-if="picture"
      :picture-id="picture.id"
      :style="{ maxHeight: `calc(100% - ${offset}px)` }"
      :size="size ? size : 600"
      :lazy="false"
      @rawLoad="dimension"
    ></api-picture>
    <h5
      v-if="title"
      :style="{ maxWidth: `none` }"
      class="text-xsmall image-caption"
      v-html="title"
    ></h5>
  </div>
</template>
<script>
import { objectFitImageRealDims } from "../../../../../util/func";
import { types as t } from "../../../../../store/actions/pictures";
import ApiPicture from "../../../../../components/Form/ApiPicture";

export default {
  name: "image-fiche",
  components: { ApiPicture },
  data() {
    return {
      offset: 0,
      w: 9999,
      picture: null
    };
  },
  props: {
    title: {},
    id: {},
    format: {},
    density: {},
    bull: {},
    size: {
      type: Number,
      required: false
    }
  },
  methods: {
    async getPicture() {
      if (typeof this.id !== "undefined" && this.id !== null) {
        this.picture = await this.$store.dispatch(t.GET_PICTURE, this.id);
      }
    },
    async dimension() {
      this.w = 9999;
      this.offset = 0;
      await new Promise(r => setTimeout(r, 50));
      let a = this.$el && this.$el.querySelector(".image-caption");
      if (!a) return;
      while (this.offset !== a.getBoundingClientRect().height) {
        this.offset = a.getBoundingClientRect().height;
        this.w = objectFitImageRealDims(this.$el.querySelector("img")).width;
        await new Promise(r => setTimeout(r, 50));
      }
      this.w = objectFitImageRealDims(this.$el.querySelector("img")).width;
      this.offset = a.getBoundingClientRect().height;
    }
  },
  async mounted() {
    this.getPicture();
  },
  watch: {
    format() {
      this.dimension();
    },
    density() {
      this.dimension();
    }
  }
};
</script>
